module.exports = __webpack_public_path__ + "img/menu03.921083ce.svg";